/* eslint-disable max-len */
import React from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const Hamburger = ({
    title,
    titleId,
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        {...props}
        aria-labelledby={titleId}
        height="1em"
        width="1em"
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="none"
            stroke="#FFF"
            strokeLinecap="round"
            d="M.5.5h18m-18 16h18m-18-8h18"
        />
    </svg>
);

export default Hamburger;
